import { Shark, Utils } from "shark-mvc";
import moment from "moment-timezone";

import NousCoreModel from "./NousCoreModel";

import activeWorkSessionDisplayComponent from "../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
import workSessionDetailsModalComponent from "../components/workSessionDetailsModal/workSessionDetailsModalComponent";

class WorkSession extends NousCoreModel {
	activityColor = "";
	clientGuid = "";
	clientName = "";
	description = "";
	elapsedTime = "0:00:00";
	elapsedTime_hh = "00";
	elapsedTime_mm = "00";
	elapsedTime_ss = "00";
	endDate = "0000-00-00 00:00:00";
	extraData = {
		urgent: false,
	};
	projectGuid = "";
	projectName = "";
	startDate = "0000-00-00 00:00:00";
	taskGuid = "";
	taskName = "";
	userGuid = "";

	__defaultDescription = "Cosa hai fatto?";
	__endDateDDMM = "";
	__loggedUserCanEdit = false;
	__organizationGuid = "";
	__ownerInitials = "";
	__ownerName = "";
	__ownerPictureURL = "";
	__projectName = "";
	__running = false;
	__selected = false;
	__startDateDDMM = "";
	__taskName = "";
	__userData = {};

	__userInternalCost = 0;
	
	constructor (data) {
		super(data, "WorkSession");
		
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		// if (this.description === this.__defaultDescription) {
		// 	exportData.description = "";
		// }

		if (this.endDate !== "0000-00-00 00:00:00") {
			exportData.endDate = this.exportDateField("endDate");
		}
	
		if (this.startDate !== "0000-00-00 00:00:00") {
			exportData.startDate = this.exportDateField("startDate");
		}
	
		exportData.extraData = this.exportObjectField("extraData");
			
		return exportData;
	}

	parseDuration () {
		this.durationMS = this.endDate?.diff(this.startDate);
		this.durationMS = isNaN(this.durationMS) ? 0 : this.durationMS;
		this.duration = moment.duration(this.durationMS);
		this.__durationLabel = this.duration.format("HH:mm:ss", { trim: false });
	}

	getDuration (client) {
		const { allUserMembershipList } = Shark.get();

		if (!this.durationMS || !this.duration || !this.__durationLabel) {
			this.parseDuration();
		}

		// Alice Was Here
		// this.durationMS = this.endDate.diff(this.startDate);
		// this.durationMS = isNaN(this.durationMS) ? 0 : this.durationMS;
		// this.duration = moment.duration(this.durationMS);
		// this.__durationLabel = this.duration.format("HH:mm:ss", { trim: false });

		// this.__multipliedDuration = this.durationMS * client.paymentMultiplier;
		// this.__multipliedDuration = isNaN(this.__multipliedDuration) ? 0 : this.__multipliedDuration;

		// this.__multipliedDurationLabel = moment.duration(this.__multipliedDuration).format("HH:mm:ss", { trim: false });

		if (allUserMembershipList) {
			const workSessionUserMembership = allUserMembershipList.filter(item => item.userGuid === this.userGuid && item.organizationGuid === client.organizationGuid)?.[0];
			
			if (workSessionUserMembership) {
				// console.log("%cQUESTA", "background-color: cyan; color: #000;", workSessionUserMembership.settings);

				this.__userInternalCost = (workSessionUserMembership.settings.internalCost * (this.durationMS / 3600000));
				this.__userInternalCostLabel = Shark.$store.moneyFormatter.format(this.__userInternalCost);
				this.__userExternalCost = (workSessionUserMembership.settings.externalCost * (this.durationMS / 3600000));
				this.__userExternalCostLabel = Shark.$store.moneyFormatter.format(this.__userExternalCost);
				
				this.__userMultipliedExternalCost = (workSessionUserMembership.settings.externalCost * (this.__multipliedDuration / 3600000));
				this.__userMultipliedExternalCostLabel = Shark.$store.moneyFormatter.format(this.__userMultipliedExternalCost);
			}
		}
		
		if (this.__userInternalCost === 0) {
			if (this?.__userData?.preferences) {
				this.__userInternalCost = (this.__userData.preferences.internalCost * (this.durationMS / 3600000));
				this.__userInternalCostLabel = Shark.$store.moneyFormatter.format(this.__userInternalCost);
				this.__userExternalCost = (this.__userData.preferences.externalCost * (this.durationMS / 3600000));
				this.__userExternalCostLabel = Shark.$store.moneyFormatter.format(this.__userExternalCost);
				
				this.__userMultipliedExternalCost = (this.__userData.preferences.externalCost * (this.__multipliedDuration / 3600000));
				this.__userMultipliedExternalCostLabel = Shark.$store.moneyFormatter.format(this.__userMultipliedExternalCost);
			}
			else {
				this.__userMultipliedExternalCost = 0;
			}
		}

		switch (client.paymentCalculationType) {
			case 1:
				this.__invoiceValue = (client.fixedHourlyValue * (this.duration / 3600000));
				// this.__invoiceValue = isNaN(this.__invoiceValue) ? 0 : this.__invoiceValue;
				break;
			case 2:
				this.__invoiceValue = this.__userMultipliedExternalCost;
				// this.__invoiceValue = isNaN(this.__invoiceValue) ? 0 : this.__invoiceValue;
				break;
			default:
				this.__invoiceValue = 0;
				break;
		}
		this.__invoiceValueLabel = Shark.$store.moneyFormatter.format(this.__invoiceValue);
		// this.paymentCalculationType = 0;//[1: Valore orario fisso, 2: Valore orario per utente, 3: Progetti a preventivo]
		// console.log(this)
		return this.durationMS;
	}

	import (data, options) {
		super.import(data, options);
		
		// non odiare alice per l'ordine alfabetico ma parso la start dopo la end mi si rompe parseDuration(); e volevo eviare un if aggiuntivo
		if (this.importDateField("startDate", data.startDate)) {
			this.__startDate = this.startDate.format("YYYY-MM-DD");
			this.__startTime = this.startDate.format("HH:mm:ss");
			this.__startDateDDMM = this.startDate.format("DD/MM");
			this.__startDateLabel = this.startDate.format("DD/MM/YYYY - HH:mm:ss");
		}
		
		if (this.importDateField("endDate", data.endDate)) {
			this.__endDate = this.endDate.format("YYYY-MM-DD");
			this.__endTime = this.endDate.format("HH:mm:ss");
			this.__endDateDDMM = this.endDate.format("DD/MM");
			this.__endDateLabel = this.endDate.format("DD/MM/YYYY - HH:mm:ss");
			// this.__running = !this.endDate.isValid(); // Questo sarebbe più giusto qui
			this.parseDuration();
		}
		else {
			this.__endDateLabel = "Non conclusa";
		}
	

	
		this.__isUrgent = this.extraData.urgent;
		this.__projectName = this.projectName;
		this.__running = typeof this.endDate.isValid === "function" && !this.endDate.isValid();
		this.__taskName = this.taskName;

		this.parseProjectName();
		this.parseTaskName();

		const userList = Shark.get("userList");
		if (userList) {
			this.__userData = Utils.safp(userList, "guid", this.userGuid);

			if (this.__userData) {
				this.__ownerInitials = this.__userData.__initials;
				// Dave. questo probabilmente dovrebbe essere il nome dell'Utente nell'organizzazione.
				this.__ownerName = this.__userData.__fullName;
				this.__ownerPictureURL = this.__userData.pictureURL;
			}
		}

		this.__loggedUserCanEdit = this.userGuid === Shark.$store.currUser.guid;

		this.description = this.description.replace(/</g, "&lt;").replace(/>/g, "&gt;"); // Fix momentaneo
	}

	on__endDateChanged (event, data) {
		this.endDate = moment(data.newValue + " " + this.__endTime);
	}

	on__endTimeChanged (event, data) {
		this.endDate = moment(this.__endDate + " " + data.newValue);
	}

	on__startDateChanged (event, data) {
		this.startDate = moment(data.newValue + " " + this.__startTime);
	}

	on__startTimeChanged (event, data) {
		this.startDate = moment(this.__startDate + " " + data.newValue);
	}

	onExtraData_urgentChanged () {
		activeWorkSessionDisplayComponent.startSaveDescriptionTimer();
	}

	onProjectGuidChanged () {
		this.parseProjectName();
	}

	onTaskGuidChanged () {
		// console.log("task guid chaged in model");
		this.parseTaskName();
	}

	parseClientName (clientList) {
		if (this.clientGuid) {
			const newClient = Utils.safp(clientList || Shark.$store.clientList, "guid", this.clientGuid);

			if (newClient) {
				this.clientName = newClient.name;
			}
		}
	}

	parseProjectName (projectList) {
		// projectList non dovrebbe più servire in ingresso 
		if (!projectList) {
			projectList = Shark.$store.projectList;
		}
		
		if (projectList) {
			var newPrj = Utils.safp(projectList, "guid", this.projectGuid);
			
			this.set({
				projectName: newPrj ? newPrj.name : "",
				__projectName: newPrj ? newPrj.name : "",
				__organizationGuid: newPrj ? newPrj.organizationGuid : "",
			});
			
			if (newPrj?.clientGuid) {
				this.clientGuid = newPrj.clientGuid;
			}
		}// Schifezza di Dave
	}

	parseTaskName (taskList) {
		// taskList non dovrebbe più servire in ingresso 

		if (!taskList) {
			taskList = Shark.$store.taskList || Shark.$store.wsTaskList;
		}
		
		if (taskList) {
			//DAve: Questo schifo sotto serve perché ho ancora "guid" che sono dei numeri.
			this.taskGuid = this.taskGuid.toString();
			
			// Dave: Comunque questa roba sotto è tutta da rifare
			let newTask = Utils.safp(taskList, "guid", this.taskGuid);

			if (!newTask) {
				newTask = Utils.safp(Shark.$store.taskList, "guid", this.taskGuid, "first");
			}
			if (!newTask) {
				// Dave: Questa roba fa schifo, basta store locali
				if (workSessionDetailsModalComponent.get("wsDetailsTaskList")) {	
					newTask = Utils.safp(workSessionDetailsModalComponent.get("wsDetailsTaskList"), "guid", this.taskGuid, "first");
				}
			}
			
			// console.log("taskIdChanged newTask", this, newTask);
			
			this.set({
				taskName: newTask ? newTask.name : "",
				__taskName: newTask ? newTask.name : "",
			});
		}

		// Dave: Ma siamo sicuri che devo settarlo su SHark??? Ma perché??
		// Shark.set("currTask", newTask);
	}

	parseActivityColor (projectList, organizationMembershipList) {
		if (!this.__organizationGuid) {
			this.parseProjectName(projectList);
		}
		var newOrg = Utils.safp(organizationMembershipList || Shark.get("organizationMembershipList"), "guid", this.__organizationGuid);

		this.activityColor = newOrg ? newOrg.activityColor : "color-0";
	}

	// onDataChanged (data) {
	// 	switch (data.property) {
	// 		case "taskGuid":
	// 			console.log("taskGuidChanged", data, this);

	// 			var newValue = data.newValue.toString();
	// 			var newTask = Utils.safp(Shark.get("taskList"), "guid", newValue, "first");

	// 			if (!newTask) {
	// 				// Dave: Questa roba fa schifo, basta store locali
	// 				newTask = Utils.safp(workSessionDetailsModalComponent.get("wsDetailsTaskList"), "guid", newValue, "first");
	// 			}
	// 			// var oldTask = Utils.safp(Shark.get("taskList"), "guid", data.oldValue.toString(), "first");

	// 			Shark.set("currTask", newTask);
	// 			console.log("taskIdChanged newTask", this, newTask);

	// 			// Shark.get("currWorkSession").taskName = newTask.name;
	// 			// Shark.get("currWorkSession").__taskName = newTask.name;
	// 			this.set({
	// 				taskName: newTask ? newTask.name : "",
	// 				__taskName: newTask ? newTask.name : "",
	// 			});
	// 			//Shark.render();
	// 			break;
	// 	}
	// }

	startTime () {
		if (this.startDate !== "0000-00-00 00:00:00") {
			return this.startDate.format("H:mm:ss");
		}
		else {
			return "--:--";
		}
	}

	updateElapsedTime () {
		var now = moment();
		var difference = now.diff(this.startDate);
		var days = now.diff(this.startDate, "days");
		
		days = days > 0 ? days + ":" : "";
	
		//oggetto elapsed time 
		this.set({
			elapsedTime: days + moment(difference).utc().format("HH:mm:ss"),
			__endDateDDMM: now.format("DD/MM"),
			__endTime: now.format("HH:mm:ss"),
		});
		this.clean(["elapsedTime", "__endDateDDMM", "__endTime"]);
	}

	validate () {
		const errors = [];

		if (this.projectGuid === "") {
			errors.push({
				error: Shark.$store.labels.errors.you_must_select_a_project,
				field: "projectGuid",
			});
		}
		if (this.taskGuid === "") {
			errors.push({
				error: Shark.$store.labels.errors.you_must_select_a_task,
				field: "taskGuid",
			});
		}

		return errors;
	}
}

Shark.registerModel("WorkSession", WorkSession);

export default WorkSession;